import { Modal } from "antd";
import i18n from "@/i18n";

// eslint-disable-next-line max-params
export default function syncConfirm(
  content: string,
  title = "提示",
  cancelText?: string,
  okText?: string
): Promise<boolean> {
  return new Promise((resolve) => {
    Modal.confirm({
      title,
      content,
      okText: okText || i18n.t("common:button.ok"),
      cancelText: cancelText || i18n.t("common:button.cancel"),
      onOk() {
        resolve(true);
      },
      onCancel() {
        resolve(false);
      }
    });
  });
}
export function syncConfirmNew(content: any, title = "提示", options = {}): Promise<boolean> {
  return new Promise((resolve) => {
    Modal.confirm({
      title,
      content,
      className: "task-common-modal-lb",
      centered: true,
      okText: i18n.t("common:button.ok"),
      cancelText: i18n.t("common:button.cancel"),
      onOk() {
        resolve(true);
      },
      onCancel() {
        resolve(false);
      },
      ...options
    });
  });
}

export function syncWarn(content: any, title = "提示", options = {}): Promise<boolean> {
  return new Promise((resolve) => {
    Modal.warning({
      title,
      content,
      centered: true,
      className: "task-common-modal-lb",
      okText: i18n.t("common:button.ok"),
      onOk() {
        resolve(true);
      },
      ...options
    });
  });
}
